import { useState, useEffect } from "react";
import { Globe } from "lucide-react";
import api from "@/lib/api";
import { setCountry } from "@/components/admin/finance/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PageHeader } from "@/components/admin/AdminUI";
import Expenses from "@/components/admin/finance/Expenses";
import Requests from "@/components/admin/finance/Requests";
import Advances from "@/components/admin/finance/Advances";
import Invoices from "@/components/admin/finance/Invoices";
import Budgets from "@/components/admin/finance/Budgets";
import Treasury from "@/components/admin/finance/Treasury";
import Reports from "@/components/admin/finance/Reports";
import FinanceSettings from "@/components/admin/finance/FinanceSettings";

const TABS = [
  ["depenses", "Dépenses", Expenses],
  ["demandes", "Demandes", Requests],
  ["avances", "Avances", Advances],
  ["factures", "Factures", Invoices],
  ["budgets", "Budgets", Budgets],
  ["tresorerie", "Trésorerie", Treasury],
  ["rapports", "Rapports", Reports],
  ["config", "Paramètres", FinanceSettings],
];

export default function Finance() {
  const [country, setSel] = useState("CI");
  const [countries, setCountries] = useState([{ code: "CI", name: "Côte d'Ivoire" }]);
  useEffect(() => { api.get("/finance/countries").then(({ data }) => setCountries(data)).catch(() => {}); }, []);
  setCountry(country); // live binding read by all finance components (remounted via key)

  const selector = (
    <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-[#111827] border border-[#1E293B]">
      <Globe className="w-4 h-4 text-[#4CB944]" />
      <select data-testid="finance-country-select" value={country}
        onChange={(e) => { setCountry(e.target.value); setSel(e.target.value); }}
        className="bg-transparent text-white text-sm focus:outline-none">
        {countries.map((c) => <option key={c.code} value={c.code} className="bg-[#111827]">{c.name}</option>)}
      </select>
    </div>
  );

  return (
    <div>
      <PageHeader title="Finance — Dépenses" subtitle="Dépenses, demandes, avances, factures, budgets et trésorerie — isolées par pays." action={selector} />
      <Tabs defaultValue="depenses">
        <TabsList className="dark bg-[#111827] border border-[#1E293B] flex-wrap h-auto">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`finance-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , Comp]) => <TabsContent key={k} value={k} className="mt-4"><Comp key={country} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
